import { useContext } from 'react';
import { FileUploadContext, FileUploadContextType } from './FileUploadContext';

export const useFileUpload = (): FileUploadContextType => {
  const context = useContext(FileUploadContext);
  if (context === undefined) {
    throw new Error('useFileUpload must be used within a FileUploadProvider');
  }
  return context;
};
